import React, { useEffect, useState } from 'react';
import {
  Backdrop,
  CircularProgress,
  Typography,
  Box,
  LinearProgress,
} from '@mui/material';
import { LoadingService } from '../../services/errorService';

interface LoadingState {
  [key: string]: boolean;
}

const LoadingOverlay: React.FC = () => {
  const [loadingStates, setLoadingStates] = useState<LoadingState>({});
  const [loadingMessage, setLoadingMessage] = useState<string>('');

  useEffect(() => {
    // Subscribe to loading service
    const unsubscribe = LoadingService.subscribe((states) => {
      setLoadingStates(states);
      
      // Set appropriate loading message based on active operations
      const activeOperations = Object.keys(states).filter(key => states[key]);
      if (activeOperations.length > 0) {
        const messages: { [key: string]: string } = {
          navigation: 'Navigating...',
          cart: 'Updating cart...',
          auth: 'Authenticating...',
          data: 'Loading data...',
          payment: 'Processing payment...',
          upload: 'Uploading files...',
          api: 'Connecting to server...',
        };
        
        const operation = activeOperations[0];
        setLoadingMessage(messages[operation] || 'Loading...');
      } else {
        setLoadingMessage('');
      }
    });

    return unsubscribe;
  }, []);

  const isLoading = Object.values(loadingStates).some(state => state);

  if (!isLoading) {
    return null;
  }

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
      }}
      open={isLoading}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <CircularProgress color="primary" size={60} />
        {loadingMessage && (
          <Typography variant="h6" component="div">
            {loadingMessage}
          </Typography>
        )}
        <Box sx={{ width: 200, mt: 1 }}>
          <LinearProgress color="primary" />
        </Box>
      </Box>
    </Backdrop>
  );
};

export default LoadingOverlay;